import { COLLECTIONS } from '../../constants/collections';
import { CONFIG_CATEGORIES } from '../../constants/systemConfig';
import { createDocument, getAllDocuments, deleteDocument } from './firestoreService';

// ============ TRANSPORT MODE CONFIGS (NAKLİYE ŞEKİLLERİ - FTL/LTL) ============

// Create transport mode configuration
export const createTransportModeConfig = async (configData) => {
    const data = {
        ...configData,
        category: CONFIG_CATEGORIES.TRANSPORT_MODES,
        isActive: true,
        createdAt: new Date(),
        updatedAt: new Date()
    };
    return await createDocument(COLLECTIONS.SYSTEM_CONFIGS, data);
};

// Get all transport modes for a tenant
export const getTransportModes = async (tenantId, activeOnly = true) => {
    // Simplified query
    const conditions = [
        { type: 'where', field: 'tenantId', operator: '==', value: tenantId },
        { type: 'where', field: 'category', operator: '==', value: CONFIG_CATEGORIES.TRANSPORT_MODES }
    ];

    let results = await getAllDocuments(COLLECTIONS.SYSTEM_CONFIGS, conditions);

    if (activeOnly) {
        results = results.filter(item => item.isActive !== false);
    }

    // Sort client side
    return results.sort((a, b) => a.name.localeCompare(b.name));
};

// Delete transport mode
export const deleteTransportModeConfig = async (configId) => {
    return await deleteDocument(COLLECTIONS.SYSTEM_CONFIGS, configId);
};
